import { useTranslation } from 'react-i18next';
import { useToast } from '@/legacy/hooks';
import { useNavigate } from 'react-router';
import { paths } from '@/app/router/path';
import { successMessageTradPrefix } from '@/legacy/i18n';
import { resolveApiError } from '@/shared/api-error';
import { useFakeAccessMutation, type FakeAccessVars } from '../api/hooks/useFakeAccessMutation';

export const useFakeAccess = ({ onClose }: { onClose?: () => void }) => {
	const { t } = useTranslation();
	const { showToast } = useToast();
	const navigate = useNavigate();

	const { mutate, isPending, isError, error } = useFakeAccessMutation({
		onSuccess: (_data, { companyName, navigateOnSuccess }) => {
			showToast(
				t(`${successMessageTradPrefix}.you_logged_in_with_the_company`, {
					company: companyName ?? '',
				}),
				'success',
			);
			onClose?.();
			if (navigateOnSuccess) navigate(paths.home());
		},
		onError: (err) => {
			showToast(resolveApiError(err).message.text, 'error');
		},
	});

	const loginFakeAccess = (vars: FakeAccessVars) => mutate(vars);

	return { loginFakeAccess, isPending, isError, error };
};
